import React from 'react';
import { useDrag } from 'react-dnd';
import Parts from "components/Parts"
import "react-big-calendar/lib/css/react-big-calendar.css"
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss'

const ItemTypes= {
	BOX: 'box',};
const DndItem = ({ event,parent }) => {
	const [{ isDragging }, drag] = useDrag({

		item: { id: event.id,title:event.title,start:event.start,end:event.end ,type:ItemTypes.BOX },
		// parent.dragFromOutsideItem()
		end: (item) => {
			const dropResult = parent.onDropFromOutside(item.id,item.title,item.start,item.end,1);

			if (item && dropResult) {

			}
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});
	const opacity = isDragging ? 0.4 : 1;
	return (<div ref={drag} style={{ opacity }} className={"rbc-event"}>
		{event.title}

	</div>);
};
export default DndItem;
